import React, { useState, useEffect } from "react";
import styles from "../styles/Remittance.module.css";
import remit from "../assets/Rem.jpg";
import tarns from "../assets/money.svg";
import secure from "../assets/rate.svg";
import view from "../assets/friendly.svg";
import add from "../assets/secur.svg";
import Rem from "../assets/Rem.jpg";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const Remittance = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  const [isMac, setIsMac] = useState(false);

  useEffect(() => {
    if (navigator.platform.toLowerCase().includes("mac")) {
      setIsMac(true);
    }
  }, []);
  return (
    <div className={styles.container}>
    <div >
      <Header />
      <section className={styles.hero}>
        <div className={styles.heroLeft}>
          <p style={{ color: "green", fontSize: "30px",  fontWeight:"bold" }}>
            ARIF REMIT
          </p>
          <h1 style={{ marginTop: "10px", color: "black", Width:"600px" }}>
            Cross-Border Money Transfer in Ethiopia
          </h1>
          <p style={{ fontSize: "17px", color: "black", maxWidth: "560px" }}>
            Send money home faster and more securely with Arif Remit — a
            cross-border money transfer service built for the Ethiopian diaspora.
          </p>
          <Link to="/ContactUs">
            <button className={styles.primaryButton}>Contact us →</button>
          </Link>
        </div>
        <div className={styles.heroRight}>
          <img
            src={remit}
            alt="Payment Devices"
            style={{
              width: "100%",
              maxWidth: "450px",
              height: "250px",
              borderRadius: "20px",
              marginTop: "50px",
            }}
          />
        </div>
      </section>

      <div className={styles.fetureParent}>
        <section
          style={{ marginTop: "50px" }}
          className={styles.solutionSection}
        >
          <div className={styles.topSession}>
            <p style={{ fontSize: "1.6em" }} className={styles.sectionLabel}>
              KEY FEATURE
            </p>
            <h2
              className={styles.sectionHead}
              style={{
                fontSize: "2.6rem",
                color: "black",
                marginBottom: "20px",
              }}
            >
              Seamless Global Money Transfers
            </h2>
            <p
              className={styles.paragra}
              style={{
                fontSize: "1.3rem",
                color: "black",
                marginBottom: "5px",
                textAlign: "center",
              }}
            >
              Arif Remit is our latest offering, designed to make sending money
              home faster, easier, and more{" "}
              <span className={styles.responsiveBreak}>
                <br />
              </span>
              secure for the Ethiopian Diaspora community worldwide.
            </p>
          </div>
        </section>
        </div>


        <section
          className={styles.domesticPaymentsSection}
        >
          <div className={styles.paymentBox}>
            <div className={styles.leftContent}>
              <div className={styles.featureBlock}>
            
                <h3 style={{color:"green", fontSize:'20px'}}>Multi-Bank Support</h3>
                <p style={{fontSize:'16px'}}>Send directly to accounts at top Ethiopian banks like Zemen Bank, CBE, Awash, BOA, and more. Compare exchange rates across providers and choose what works best for you.</p>
              </div>

              <div className={styles.featureBlock}>
            
                <h3 style={{color:"green", fontSize:'20px'}}>
International Airtime Top-Up</h3>
                <p style={{fontSize:'16px'}}>With Arif Remit, users can instantly top up airtime in Ethiopia from anywhere in the world. The service allows quick airtime recharges.</p>
              </div>

                 <div className={styles.featureBlock}>
              
                <h3 style={{color:"green", fontSize:'20px'}}>Payment Link Generation</h3>
                <p style={{fontSize:'16px'}}>Need to request money? Create a secure payment link and share it via SMS, email, or any messaging platform. The recipient can pay via bank, wallet, or cash pickup.</p>
              </div>
            </div>

            <div className={styles.rightContent}>
              <div className={styles.featureBlock}>
               
                <h3 style={{color:"green", fontSize:'20px'}}> Wallet Transfers</h3>
                <p style={{fontSize:'16px'}}>Send money straight to mobile wallets such as Telebirr, M-Pesa, and CBE Birr, allowing your recipients to access their funds instantly and conveniently.</p>
              </div>

              <div className={styles.featureBlock}>
          
                <h3 style={{color:"green", fontSize:'20px'}}>Cash Pickup Locations</h3>
                <p style={{fontSize:'16px'}}>Prefer cash? Send to verified agents or partner forex offices across Ethiopia, where your recipient can collect the money in-person.</p>
              </div>

               <div className={styles.featureBlock}>
              
                <h3 style={{color:"green", fontSize:'20px'}}>Utility Bill Payment</h3>
                <p style={{fontSize:'16px'}}>Arif Remit simplifies how Ethiopians abroad support their families back home by enabling direct utility bill payments. Users can conveniently pay for essential services such as electricity, water, and internet, all within the app.</p>
              </div>
            </div>
          </div>
        </section>

        
    
      <section>
        <div className={styles.experience}>
          <div className={styles.TopSession}>
            <p className={styles.sectionLabel}>TAKE YOUR FIRST EXPERIENCE</p>
            <h2 className={styles.sectionTitle}>How it works?</h2>
          </div>
          <div
            style={{ overflow: "hidden" }}
            className={styles.ourSolutionsSliderContainer}
          >
            {" "}
            {/* Changed class name */}
            <div className={styles.solutionBox}>
              <p
                style={{
                  fontSize: "20px",
                  color: "green",
                  overflow:'hidden',
                  // marginBottom: "40px",
                }}
              >
                STEP 1
              </p>
              <h4 style={{ fontSize: "20px", overflow:'hidden' }}> Choose How You Want to Proceed</h4>
              <p
                style={{ fontSize: "16px", color: "black", overflow:'hidden' }}
                className={styles.paragraph}
              >
               Start by selecting Register or Continue as Guest for quick use.
              </p>
            </div>
            <p
              className={styles.arrow}
              style={{
                fontSize: "20px",
                textAlign: "center",
                margin: "0 10px",
                color: "green",
              }}
            >
              ➡️
            </p>
            <div className={styles.solutionBox}>
              <p
                style={{
                  fontSize: "20px",
                  color: "green",
                  // marginBottom: "10px",
                }}
              >
                STEP 2
              </p>
              <h4 style={{ fontSize: "20px" }}>
             Select Transfer Type
              </h4>
              <p
                style={{ fontSize: "16px", color: "black" }}
                className={styles.paragraph}
              >
               Choose between Bank Transfer, Wallet Transfer, or Cash Pickup.
              </p>
            </div>
            <p
              className={styles.arrow}
              style={{
                fontSize: "20px",
                textAlign: "center",
                margin: "0 10px",
                color: "green",
              }}
            >
              ➡️
            </p>
            <div className={styles.solutionBox}>
              <p
                style={{
                  fontSize: "20px",
                  color: "green",
                  // marginBottom: "40px",
                }}
              >
                STEP 3
              </p>
              <h4 style={{ fontSize: "20px" }}>Enter Recipient Details</h4>
              <p
                style={{ fontSize: "16px", color: "black" }}
                className={styles.paragraph}
              >
                 Fill in the recipient’s information and the amount to be sent.
              </p>
            </div>
            <p
              className={styles.arrow}
              style={{
                fontSize: "20px",
                textAlign: "center",
                margin: "0 10px",
                color: "green",
              }}
            >
              ➡️
            </p>
            <div className={styles.solutionBox}>
              <p
                style={{
                  fontSize: "20px",
                  color: "green",
                  // marginBottom: "10px",
                }}
              >
                STEP 4
              </p>
              <h4 style={{ fontSize: "20px" }}> Confirm & Send</h4>
              <p
                style={{ fontSize: "16px", color: "black" }}
                className={styles.paragraph}
              >
 Review the exchange rate and total, then complete your secure transaction.
              </p>
            </div>
          </div>
          {/* <div className={styles.accept}>
            <button
              style={{
                backgroundColor: "var(--primary-green)",
                color: "white",
                alignItems: "center",
                justifyContent: "center",
                padding: "10px 20px",
                border: "none",
                borderRadius: "10px",
              }}
            >
              Accept Now →
            </button>
          </div> */}
        </div>
      </section>
      <section className={styles.bottom}>
        <div
          className={styles.bottom}
          style={{
            backgroundColor: "var(--primary-green)",
            color: "#fff",
            padding: "20px 30px",
            borderRadius: "35px",
            margin: "40px 70px 65px 50px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "0 auto",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
          >
            {/* Text Content */}
            <div style={{ flex: "1", maxWidth: "550px", marginBottom: "30px" }}>
              <h2
                style={{
                  fontSize: "20px",
                  marginBottom: "15px",
                  color: "white",
                }}
              >
                Move Money Beyond Borders
              </h2>
              <p style={{ fontSize: "16px" }}>
                <span style={{ color: "white", fontSize: "1.2em" }}>✦</span> Arif Remit keeps it simple; no confusing steps, no unnecessary delays. Just a reliable way to send money when it matters, from wherever you are.
              </p>
              {/* <button
                className={styles.but}
                style={{
                  backgroundColor: "#fff",
                  color: "green",
                  border: "none",
                  padding: "15px 30px",
                  borderRadius: "5px",
                  fontSize: "16px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Join Now
              </button> */}
            </div>

            {/* Image Side */}
            <div
              style={{ flex: "1", display: "flex", justifyContent: "flex-end" }}
            >
              <img
                src={Rem}
                alt="Payment Terminal"
                style={{
                  width: "100%",
                  maxWidth: "450px",
                  height: "auto",
                  objectFit: "cover",
                  borderRadius: "25px",
                  border: "5px solid green",
                }}
              />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
    
</div>
  );
};

export default Remittance;
